import { render, staticRenderFns } from "./WaitProExpendReimbursementDetail.vue?vue&type=template&id=cabbbbd8&"
import script from "./WaitProExpendReimbursementDetail.vue?vue&type=script&lang=js&"
export * from "./WaitProExpendReimbursementDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitProExpendReimbursementDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports